const colruyt = [
  {
    placeId: 902,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "AALST (COLRUYT)",
    branchId: "4156",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.933074,
      longitude: 4.0538972,
    },
    address: {
      streetName: "BRUSSELSE STEENWEG",
      houseNumber: "41",
      postalcode: "9300",
      cityName: "AALST",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4156",
    routeUrl: "https://maps.apple.com/?daddr=50.933074,4.0538972",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 946,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "AALTER (COLRUYT)",
    branchId: "4218",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0784761,
      longitude: 3.4500133,
    },
    address: {
      streetName: "LOSTRAAT",
      houseNumber: "66",
      postalcode: "9880",
      cityName: "AALTER",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4218",
    routeUrl: "https://maps.apple.com/?daddr=51.0784761,3.4500133",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 950,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "AARSCHOT (COLRUYT)",
    branchId: "4222",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9760369,
      longitude: 4.8110969,
    },
    address: {
      streetName: "LEUVENSESTEENWEG",
      houseNumber: "241",
      postalcode: "3200",
      cityName: "AARSCHOT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4222",
    routeUrl: "https://maps.apple.com/?daddr=50.9760369,4.8110969",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 886,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ALSEMBERG (COLRUYT)",
    branchId: "4138",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7415212,
      longitude: 4.336719,
    },
    address: {
      streetName: "BRUSSELSESTEENWEG",
      houseNumber: "19",
      postalcode: "1652",
      cityName: "ALSEMBERG",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4138",
    routeUrl: "https://maps.apple.com/?daddr=50.7415212,4.336719",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 783,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "AMAY (COLRUYT)",
    branchId: "3853",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5599284,
      longitude: 5.3061951,
    },
    address: {
      streetName: "CHAUSSEE DE TONGRES",
      houseNumber: "247",
      postalcode: "4540",
      cityName: "AMAY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3853",
    routeUrl: "https://maps.apple.com/?daddr=50.5599284,5.3061951",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 650,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ANDENNE (COLRUYT)",
    branchId: "3596",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4917055,
      longitude: 5.0930033,
    },
    address: {
      streetName: "RUE DE LA PAPETERIE",
      houseNumber: "4",
      postalcode: "5300",
      cityName: "ANDENNE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3596",
    routeUrl: "https://maps.apple.com/?daddr=50.4917055,5.0930033",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 669,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ANDERLECHT (HERBETTELN) COLR",
    branchId: "3620",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8439965,
      longitude: 4.3099483,
    },
    address: {
      streetName: "MAURICE HERBETTELAAN",
      houseNumber: "57",
      postalcode: "1070",
      cityName: "ANDERLECHT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3620",
    routeUrl: "https://maps.apple.com/?daddr=50.8439965,4.3099483",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 744,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ANDERLECHT (VEEWEYDE) COLRUYT",
    branchId: "3759",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8275378372,
      longitude: 4.3025743961,
    },
    address: {
      streetName: "BERGENSESTEENWEG",
      houseNumber: "824",
      postalcode: "1070",
      cityName: "ANDERLECHT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3759",
    routeUrl: "https://maps.apple.com/?daddr=50.8275378372,4.3025743961",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 448,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ANDERLUES (COLRUYT)",
    branchId: "3074",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.401257,
      longitude: 4.2797751,
    },
    address: {
      streetName: "RUE DE LA STATION",
      houseNumber: "4",
      postalcode: "6150",
      cityName: "ANDERLUES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3074",
    routeUrl: "https://maps.apple.com/?daddr=50.401257,4.2797751",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 681,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ANS (COLRUYT)",
    branchId: "3644",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6588119,
      longitude: 5.5324966,
    },
    address: {
      streetName: "RUE DES FRANCAIS",
      houseNumber: "88",
      postalcode: "4430",
      cityName: "ANS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3644",
    routeUrl: "https://maps.apple.com/?daddr=50.6588119,5.5324966",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 880,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ANTOING (COLRUYT)",
    branchId: "4128",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5656778,
      longitude: 3.4521636,
    },
    address: {
      streetName: "AVENUE DE L'EUROPE",
      houseNumber: "14",
      postalcode: "7640",
      cityName: "ANTOING",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4128",
    routeUrl: "https://maps.apple.com/?daddr=50.5656778,3.4521636",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 636,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CADI ANTWERPEN LANGELZENSTR",
    branchId: "3573",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.2011247,
      longitude: 4.395306,
    },
    address: {
      streetName: "LANGE ELZENSTRAAT",
      houseNumber: "35A",
      postalcode: "2018",
      cityName: "ANTWERPEN 1",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3573",
    routeUrl: "https://maps.apple.com/?daddr=51.2011247,4.395306",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2781,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ANTWERPEN GENTPLAATS (COLRUYT)",
    branchId: "7477",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2060004,
      longitude: 4.3872453,
    },
    address: {
      streetName: "GENTPLAATS",
      houseNumber: "15",
      postalcode: "2000",
      cityName: "ANTWERPEN 1",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7477",
    routeUrl: "https://maps.apple.com/?daddr=51.2060004,4.3872453",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2643,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LINKEROEVER (COLRUYT)",
    branchId: "7190",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2198341,
      longitude: 4.363296,
    },
    address: {
      streetName: "BLANCEFLOERLAAN",
      houseNumber: "357",
      postalcode: "2050",
      cityName: "ANTWERPEN 5",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7190",
    routeUrl: "https://maps.apple.com/?daddr=51.2198341,4.363296",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 538,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ARLON (COLRUYT)",
    branchId: "3266",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 49.6832331,
      longitude: 5.799413,
    },
    address: {
      streetName: "RUE DE L'HYDRION",
      houseNumber: "15",
      postalcode: "6700",
      cityName: "ARLON",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3266",
    routeUrl: "https://maps.apple.com/?daddr=49.6832331,5.799413",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 454,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ASSE (COLRUYT)",
    branchId: "3083",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.9165932,
      longitude: 4.189811,
    },
    address: {
      streetName: "NERVIERSSTRAAT",
      houseNumber: "49A",
      postalcode: "1730",
      cityName: "ASSE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3083",
    routeUrl: "https://maps.apple.com/?daddr=50.9165932,4.189811",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 833,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ASSEBROEK (COLRUYT)",
    branchId: "4050",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.207433,
      longitude: 3.241102,
    },
    address: {
      streetName: "NIJVERHEIDSSTRAAT",
      houseNumber: "124",
      postalcode: "8310",
      cityName: "ASSEBROEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4050",
    routeUrl: "https://maps.apple.com/?daddr=51.207433,3.241102",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 621,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ATH (COLRUYT)",
    branchId: "3547",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.633502,
      longitude: 3.7882782,
    },
    address: {
      streetName: "CHAUSSEE DE BRUXELLES",
      houseNumber: "116",
      postalcode: "7800",
      cityName: "ATH",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3547",
    routeUrl: "https://maps.apple.com/?daddr=50.633502,3.7882782",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 640,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "AVELGEM (COLRUYT)",
    branchId: "3582",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.764426,
      longitude: 3.439359,
    },
    address: {
      streetName: "DOORNIKSESTEENWEG",
      houseNumber: "272",
      postalcode: "8580",
      cityName: "AVELGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3582",
    routeUrl: "https://maps.apple.com/?daddr=50.764426,3.439359",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 974,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "AVERBODE (COLRUYT)",
    branchId: "4263",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.026757,
      longitude: 4.9826536,
    },
    address: {
      streetName: "MELKERIJSTRAAT",
      houseNumber: "8",
      postalcode: "3271",
      cityName: "AVERBODE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4263",
    routeUrl: "https://maps.apple.com/?daddr=51.026757,4.9826536",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 982,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GENAPPE (COLRUYT)",
    branchId: "4283",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6154795,
      longitude: 4.4516466,
    },
    address: {
      streetName: "CHAUSSEE DE BRUXELLES",
      houseNumber: "13",
      postalcode: "1470",
      cityName: "BAISY-THY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4283",
    routeUrl: "https://maps.apple.com/?daddr=50.6154795,4.4516466",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3174,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BALEN NEW (COLRUYT)",
    branchId: "7964",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.165198346,
      longitude: 5.178819606,
    },
    address: {
      streetName: "SCHOOR",
      houseNumber: "1",
      postalcode: "2490",
      cityName: "BALEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7964",
    routeUrl: "https://maps.apple.com/?daddr=51.165198346000,5.1788196060000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 741,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BASTOGNE (COLRUYT)",
    branchId: "3747",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.011502,
      longitude: 5.723048,
    },
    address: {
      streetName: "CHAUSSEE DE HOUFFALIZE",
      houseNumber: "22",
      postalcode: "6600",
      cityName: "BASTOGNE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3747",
    routeUrl: "https://maps.apple.com/?daddr=50.011502,5.723048",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 866,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HERVE (COLRUYT)",
    branchId: "4114",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.64744,
      longitude: 5.8207,
    },
    address: {
      streetName: "OUTRE-COUR",
      houseNumber: "37",
      postalcode: "4651",
      cityName: "BATTICE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4114",
    routeUrl: "https://maps.apple.com/?daddr=50.64744,5.8207",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2673,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BEAUFAYS (COLRUYT)",
    branchId: "7254",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5769753,
      longitude: 5.6179059,
    },
    address: {
      streetName: "VOIE DE L'AIR PUR",
      houseNumber: "175",
      postalcode: "4052",
      cityName: "BEAUFAYS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7254",
    routeUrl: "https://maps.apple.com/?daddr=50.5769753,5.6179059",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2583,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BEERNEM (COLRUYT)",
    branchId: "7085",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1292944,
      longitude: 3.3218791,
    },
    address: {
      streetName: "HUBERT D'YDEWALLESTRAAT",
      houseNumber: "72",
      postalcode: "8730",
      cityName: "BEERNEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7085",
    routeUrl: "https://maps.apple.com/?daddr=51.1292944,3.3218791",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 608,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BEN-AHIN (COLRUYT)",
    branchId: "3521",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5222812,
      longitude: 5.2181089,
    },
    address: {
      streetName: "CHAUSSEE DE DINANT",
      houseNumber: "5",
      postalcode: "4500",
      cityName: "BEN-AHIN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3521",
    routeUrl: "https://maps.apple.com/?daddr=50.5222812,5.2181089",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3310,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BERCHEM (COLRUYT)",
    branchId: "7959",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.179493284,
      longitude: 4.44133948,
    },
    address: {
      streetName: "OOGSTSTRAAT",
      houseNumber: "239",
      postalcode: "2600",
      cityName: "BERCHEM (ANTW.)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7959",
    routeUrl: "https://maps.apple.com/?daddr=51.179493284000,4.4413394800000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 484,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BERINGEN (COLRUYT)",
    branchId: "3121",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0763021,
      longitude: 5.2197124,
    },
    address: {
      streetName: "KOOLMIJNLAAN",
      houseNumber: "321",
      postalcode: "3580",
      cityName: "BERINGEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3121",
    routeUrl: "https://maps.apple.com/?daddr=51.0763021,5.2197124",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 685,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BEVEREN (COLRUYT)",
    branchId: "3651",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2141848,
      longitude: 4.2511468,
    },
    address: {
      streetName: "DONKVIJVERSTRAAT",
      houseNumber: "17",
      postalcode: "9120",
      cityName: "BEVEREN-WAAS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3651",
    routeUrl: "https://maps.apple.com/?daddr=51.2141848,4.2511468",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 874,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BIERGHES (COLRUYT)",
    branchId: "4122",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6936498,
      longitude: 4.1218974,
    },
    address: {
      streetName: "ROUTE DE QUENAST",
      houseNumber: "7",
      postalcode: "1430",
      cityName: "BIERGHES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4122",
    routeUrl: "https://maps.apple.com/?daddr=50.6936498,4.1218974",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3330,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BILZEN (COLRUYT)",
    branchId: "8008",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.865164758,
      longitude: 5.525766541,
    },
    address: {
      streetName: "MAASTRICHTERSTRAAT",
      houseNumber: "18",
      postalcode: "3740",
      cityName: "BILZEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/8008",
    routeUrl: "https://maps.apple.com/?daddr=50.865164758000,5.5257665410000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 661,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BINCHE (COLRUYT)",
    branchId: "3610",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4213843,
      longitude: 4.1716297,
    },
    address: {
      streetName: "RUE ZEPHIRIN FONTAINE",
      houseNumber: "162",
      postalcode: "7130",
      cityName: "BINCHE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3610",
    routeUrl: "https://maps.apple.com/?daddr=50.4213843,4.1716297",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 717,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BLANKENBERGE (COLRUYT)",
    branchId: "3694",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.31238,
      longitude: 3.13285,
    },
    address: {
      streetName: "RUITERSTRAAT",
      houseNumber: "2",
      postalcode: "8370",
      cityName: "BLANKENBERGE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3694",
    routeUrl: "https://maps.apple.com/?daddr=51.31238,3.13285",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 687,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BONCELLES (COLRUYT)",
    branchId: "3653",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.567642,
      longitude: 5.550215,
    },
    address: {
      streetName: "ROUTE DU CONDROZ",
      houseNumber: "19",
      postalcode: "4100",
      cityName: "BONCELLES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3653",
    routeUrl: "https://maps.apple.com/?daddr=50.567642,5.550215",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 766,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BOOM (COLRUYT)",
    branchId: "3821",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.0946249,
      longitude: 4.3673019,
    },
    address: {
      streetName: "PAPENSTEENSTRAAT",
      houseNumber: "1",
      postalcode: "2850",
      cityName: "BOOM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3821",
    routeUrl: "https://maps.apple.com/?daddr=51.0946249,4.3673019",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 579,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BORNEM (COLRUYT)",
    branchId: "3465",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0914746,
      longitude: 4.2288212,
    },
    address: {
      streetName: "SINT-AMANDSESTEENWEG",
      houseNumber: "85",
      postalcode: "2880",
      cityName: "BORNEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3465",
    routeUrl: "https://maps.apple.com/?daddr=51.0914746,4.2288212",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 614,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BOUILLON (COLRUYT)",
    branchId: "3537",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 49.7927083,
      longitude: 5.0688035,
    },
    address: {
      streetName: "RUE DU COLLEGE",
      houseNumber: "32",
      postalcode: "6830",
      cityName: "BOUILLON",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3537",
    routeUrl: "https://maps.apple.com/?daddr=49.7927083,5.0688035",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1713,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BRAINE-L'ALLEUD (COLRUYT)",
    branchId: "4476",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6944836,
      longitude: 4.3654116,
    },
    address: {
      streetName: "RUE DU JARDINIER",
      houseNumber: "50",
      postalcode: "1420",
      cityName: "BRAINE-L'ALLEUD",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4476",
    routeUrl: "https://maps.apple.com/?daddr=50.6944836,4.3654116",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 617,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BRAINE-LE-CHÂTEAU (COLRUYT)",
    branchId: "3541",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6817317,
      longitude: 4.2655481,
    },
    address: {
      streetName: "RUE DE TUBIZE",
      houseNumber: "6",
      postalcode: "1440",
      cityName: "BRAINE-LE-CHATEAU",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3541",
    routeUrl: "https://maps.apple.com/?daddr=50.6817317,4.2655481",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 615,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BRAKEL (COLRUYT)",
    branchId: "3538",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7980297,
      longitude: 3.7595431,
    },
    address: {
      streetName: "GERAARDSBERGSESTRAAT",
      houseNumber: "4",
      postalcode: "9660",
      cityName: "BRAKEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3538",
    routeUrl: "https://maps.apple.com/?daddr=50.7980297,3.7595431",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 716,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BRASSCHAAT (COLRUYT)",
    branchId: "3692",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2899609,
      longitude: 4.4866286,
    },
    address: {
      streetName: "LEOPOLDSLEI",
      houseNumber: "24",
      postalcode: "2930",
      cityName: "BRASSCHAAT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3692",
    routeUrl: "https://maps.apple.com/?daddr=51.2899609,4.4866286",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 875,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BREDENE (COLRUYT)",
    branchId: "4123",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2387231,
      longitude: 2.9736245,
    },
    address: {
      streetName: "VLOEDSTRAAT",
      houseNumber: "22",
      postalcode: "8450",
      cityName: "BREDENE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4123",
    routeUrl: "https://maps.apple.com/?daddr=51.2387231,2.9736245",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 811,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BREE (COLRUYT)",
    branchId: "4000",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1391245,
      longitude: 5.60757,
    },
    address: {
      streetName: "REGENBOOGSTRAAT",
      houseNumber: "14",
      postalcode: "3960",
      cityName: "BREE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4000",
    routeUrl: "https://maps.apple.com/?daddr=51.1391245,5.60757",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 668,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BRUGGE SINT-PIETERS (COLRUYT)",
    branchId: "3619",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2219399,
      longitude: 3.2153662,
    },
    address: {
      streetName: "VEEMARKTSTRAAT",
      houseNumber: "1",
      postalcode: "8000",
      cityName: "BRUGGE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3619",
    routeUrl: "https://maps.apple.com/?daddr=51.2219399,3.2153662",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1826,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CHAPELLE (COLRUYT)",
    branchId: "5378",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.475331,
      longitude: 4.272667,
    },
    address: {
      streetName: "CLOS DU CHENE AU BOIS",
      houseNumber: "13",
      postalcode: "7160",
      cityName: "CHAPELLE-LEZ-HERLAIM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/5378",
    routeUrl: "https://maps.apple.com/?daddr=50.475331,4.272667",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 510,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CHATELET (COLRUYT)",
    branchId: "3187",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4055216,
      longitude: 4.5217659,
    },
    address: {
      streetName: "PLACE DU MARCHE",
      houseNumber: "11",
      postalcode: "6200",
      cityName: "CHATELET",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3187",
    routeUrl: "https://maps.apple.com/?daddr=50.4055216,4.5217659",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 877,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CHENEE (COLRUYT)",
    branchId: "4125",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.6074402,
      longitude: 5.6127824,
    },
    address: {
      streetName: "RUE DE BEAUFRAIPONT",
      houseNumber: "16",
      postalcode: "4032",
      cityName: "CHENEE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4125",
    routeUrl: "https://maps.apple.com/?daddr=50.6074402,5.6127824",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 757,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CINEY (COLRUYT)",
    branchId: "3799",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.3073448,
      longitude: 5.1178994,
    },
    address: {
      streetName: "RUE SAINT GILLES",
      houseNumber: "17",
      postalcode: "5590",
      cityName: "CINEY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3799",
    routeUrl: "https://maps.apple.com/?daddr=50.3073448,5.1178994",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1003,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CORBAIS (COLRUYT)",
    branchId: "4339",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.640163,
      longitude: 4.6476326,
    },
    address: {
      streetName: "GRAND'ROUTE",
      houseNumber: "89",
      postalcode: "1435",
      cityName: "CORBAIS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4339",
    routeUrl: "https://maps.apple.com/?daddr=50.640163,4.6476326",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2717,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "COURCELLES (COLRUYT)",
    branchId: "7345",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.462728708,
      longitude: 4.354385335,
    },
    address: {
      streetName: "RUE DE TRAZEGNIES",
      houseNumber: "154",
      postalcode: "6180",
      cityName: "COURCELLES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7345",
    routeUrl: "https://maps.apple.com/?daddr=50.462728708000,4.3543853350000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 864,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CUESMES (COLRUYT)",
    branchId: "4112",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4366878,
      longitude: 3.9254186,
    },
    address: {
      streetName: "PLACE DE CUESMES",
      houseNumber: "57",
      postalcode: "7033",
      cityName: "CUESMES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4112",
    routeUrl: "https://maps.apple.com/?daddr=50.4366878,3.9254186",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 646,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DAMPREMY (COLRUYT)",
    branchId: "3588",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4379269,
      longitude: 4.4390739,
    },
    address: {
      streetName: "CHAUSSEE DE BRUXELLES",
      houseNumber: "233",
      postalcode: "6020",
      cityName: "DAMPREMY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3588",
    routeUrl: "https://maps.apple.com/?daddr=50.4379269,4.4390739",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 654,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DEINZE (COLRUYT)",
    branchId: "3600",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.980767,
      longitude: 3.547323,
    },
    address: {
      streetName: "GAMPELAEREDREEF",
      houseNumber: "1",
      postalcode: "9800",
      cityName: "DEINZE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3600",
    routeUrl: "https://maps.apple.com/?daddr=50.980767,3.547323",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 700,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DENDERMONDE (COLRUYT)",
    branchId: "3671",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.029909,
      longitude: 4.1029079,
    },
    address: {
      streetName: "OUDE VEST",
      houseNumber: "98",
      postalcode: "9200",
      cityName: "DENDERMONDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3671",
    routeUrl: "https://maps.apple.com/?daddr=51.029909,4.1029079",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 489,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DEURNE NOORD (COLRUYT)",
    branchId: "3130",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2215848,
      longitude: 4.4576518,
    },
    address: {
      streetName: "EYENDIJKSTRAAT",
      houseNumber: "22",
      postalcode: "2100",
      cityName: "DEURNE (ANTWERPEN)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3130",
    routeUrl: "https://maps.apple.com/?daddr=51.2215848,4.4576518",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 897,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DEURNE ZUID (COLRUYT)",
    branchId: "4150",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2097984,
      longitude: 4.4551328,
    },
    address: {
      streetName: "HERENTALSEBAAN",
      houseNumber: "57-A",
      postalcode: "2100",
      cityName: "DEURNE (ANTWERPEN)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4150",
    routeUrl: "https://maps.apple.com/?daddr=51.2097984,4.4551328",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3813,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "Deurne Ruggeveldlaan (COLRUYT)",
    branchId: "8555",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.222910191,
      longitude: 4.479029433,
    },
    address: {
      streetName: "RUGGEVELDLAAN",
      houseNumber: "601",
      postalcode: "2100",
      cityName: "DEURNE (ANTWERPEN)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/8555",
    routeUrl: "https://maps.apple.com/?daddr=51.222910191000,4.4790294330000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 841,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DIEST (COLRUYT)",
    branchId: "4063",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9775359,
      longitude: 5.044282,
    },
    address: {
      streetName: "LEUVENSESTEENWEG",
      houseNumber: "72",
      postalcode: "3290",
      cityName: "DIEST",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4063",
    routeUrl: "https://maps.apple.com/?daddr=50.9775359,5.044282",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 878,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DIKSMUIDE (COLRUYT)",
    branchId: "4126",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0310068,
      longitude: 2.8711371,
    },
    address: {
      streetName: "RIJKSWACHTSTRAAT",
      houseNumber: "1",
      postalcode: "8600",
      cityName: "DIKSMUIDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4126",
    routeUrl: "https://maps.apple.com/?daddr=51.0310068,2.8711371",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 455,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DILBEEK (COLRUYT)",
    branchId: "3084",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8446291,
      longitude: 4.2725792,
    },
    address: {
      streetName: "NINOOFSESTEENWEG",
      houseNumber: "170",
      postalcode: "1700",
      cityName: "DILBEEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3084",
    routeUrl: "https://maps.apple.com/?daddr=50.8446291,4.2725792",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1671,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DINANT (COLRUYT)",
    branchId: "4324",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.2649342,
      longitude: 4.9498376,
    },
    address: {
      streetName: "RUE SAINT JACQUES",
      houseNumber: "355",
      postalcode: "5500",
      cityName: "DINANT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4324",
    routeUrl: "https://maps.apple.com/?daddr=50.2649342,4.9498376",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 871,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DOTTENIJS (COLRUYT)",
    branchId: "4119",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.72811,
      longitude: 3.30491,
    },
    address: {
      streetName: "ALBERT DEGANDTPLEIN",
      houseNumber: "18",
      postalcode: "7711",
      cityName: "DOTTENIJS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4119",
    routeUrl: "https://maps.apple.com/?daddr=50.72811,3.30491",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1004,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "DOUR (COLRUYT)",
    branchId: "4348",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.3971312,
      longitude: 3.7687244,
    },
    address: {
      streetName: "RUE D'ELOUGES",
      houseNumber: "104",
      postalcode: "7370",
      cityName: "DOUR",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4348",
    routeUrl: "https://maps.apple.com/?daddr=50.3971312,3.7687244",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3793,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EDEGEM (COLRUYT)",
    branchId: "9158",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.156068362,
      longitude: 4.449276447,
    },
    address: {
      streetName: "HOVESTRAAT",
      houseNumber: "52",
      postalcode: "2650",
      cityName: "EDEGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/9158",
    routeUrl: "https://maps.apple.com/?daddr=51.156068362000,4.4492764470000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 676,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EDINGEN (COLRUYT)",
    branchId: "3634",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6906623,
      longitude: 4.0324806,
    },
    address: {
      streetName: "HOVESSTRAAT",
      houseNumber: "124",
      postalcode: "7850",
      cityName: "EDINGEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3634",
    routeUrl: "https://maps.apple.com/?daddr=50.6906623,4.0324806",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 652,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EEKLO (COLRUYT)",
    branchId: "3598",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.1920426,
      longitude: 3.5738986,
    },
    address: {
      streetName: "VROMBAUTSTRAAT",
      houseNumber: "24",
      postalcode: "9900",
      cityName: "EEKLO",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3598",
    routeUrl: "https://maps.apple.com/?daddr=51.1920426,3.5738986",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 610,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EKEREN (COLRUYT)",
    branchId: "3523",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2835476,
      longitude: 4.416315,
    },
    address: {
      streetName: "KLOOSTERSTRAAT",
      houseNumber: "122",
      postalcode: "2180",
      cityName: "EKEREN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3523",
    routeUrl: "https://maps.apple.com/?daddr=51.2835476,4.416315",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 879,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ELLEZELLES (COLRUYT)",
    branchId: "4127",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7325714,
      longitude: 3.6816472,
    },
    address: {
      streetName: "RUE JEAN VINOIS",
      houseNumber: "27",
      postalcode: "7890",
      cityName: "ELLEZELLES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4127",
    routeUrl: "https://maps.apple.com/?daddr=50.7325714,3.6816472",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2221,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EPINOIS (COLRUYT)",
    branchId: "7014",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4094313,
      longitude: 4.2016888,
    },
    address: {
      streetName: "ROUTE DE CHARLEROI",
      houseNumber: "159",
      postalcode: "7134",
      cityName: "EPINOIS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7014",
    routeUrl: "https://maps.apple.com/?daddr=50.4094313,4.2016888",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2750,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EPPEGEM (COLRUYT)",
    branchId: "7459",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9682734,
      longitude: 4.4553702,
    },
    address: {
      streetName: "KREUPELSTRAAT",
      houseNumber: "32",
      postalcode: "1980",
      cityName: "EPPEGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7459",
    routeUrl: "https://maps.apple.com/?daddr=50.9682734,4.4553702",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1675,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ERQUELINNES (COLRUYT)",
    branchId: "4416",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.3167872,
      longitude: 4.1273378,
    },
    address: {
      streetName: "ROUTE DE MONS",
      houseNumber: "300",
      postalcode: "6560",
      cityName: "ERQUELINNES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4416",
    routeUrl: "https://maps.apple.com/?daddr=50.3167872,4.1273378",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 471,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ETTERBEEK (GRAYSTRAAT) COLRUYT",
    branchId: "3104",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8342712,
      longitude: 4.3792536,
    },
    address: {
      streetName: "GRAYSTRAAT",
      houseNumber: "102",
      postalcode: "1040",
      cityName: "ETTERBEEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3104",
    routeUrl: "https://maps.apple.com/?daddr=50.8342712,4.3792536",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2713,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EUPEN NEW (COLRUYT)",
    branchId: "7318",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.634432,
      longitude: 6.0235769,
    },
    address: {
      streetName: "HERBESTHALER STRASSE",
      houseNumber: "56",
      postalcode: "4700",
      cityName: "EUPEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7318",
    routeUrl: "https://maps.apple.com/?daddr=50.634432,6.0235769",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 625,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EVERE (COLRUYT)",
    branchId: "3557",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8610141,
      longitude: 4.414175,
    },
    address: {
      streetName: "OUD-STRIJDERSLAAN",
      houseNumber: "42",
      postalcode: "1140",
      cityName: "EVERE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3557",
    routeUrl: "https://maps.apple.com/?daddr=50.8610141,4.414175",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 635,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "EVERE (HAACHTSESTW) COLRUYT",
    branchId: "3571",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8750313,
      longitude: 4.4037583,
    },
    address: {
      streetName: "HAACHTSESTEENWEG",
      houseNumber: "1031",
      postalcode: "1140",
      cityName: "EVERE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3571",
    routeUrl: "https://maps.apple.com/?daddr=50.8750313,4.4037583",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 458,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "FLERON (COLRUYT)",
    branchId: "3087",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6158616,
      longitude: 5.6734336,
    },
    address: {
      streetName: "AVENUE DES MARTYRS",
      houseNumber: "45",
      postalcode: "4620",
      cityName: "FLERON",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3087",
    routeUrl: "https://maps.apple.com/?daddr=50.6158616,5.6734336",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2220,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "FLORENVILLE (COLRUYT)",
    branchId: "2214",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 49.703269,
      longitude: 5.328295,
    },
    address: {
      streetName: "RUE DE LA STATION",
      houseNumber: "77",
      postalcode: "6820",
      cityName: "FLORENVILLE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/2214",
    routeUrl: "https://maps.apple.com/?daddr=49.703269,5.328295",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 813,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "FRASNES (COLRUYT)",
    branchId: "4012",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.673165,
      longitude: 3.6305229,
    },
    address: {
      streetName: "ROUTE DE LESSINES",
      houseNumber: "4A",
      postalcode: "7911",
      cityName: "FRASNES-LEZ-BUISSENA",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4012",
    routeUrl: "https://maps.apple.com/?daddr=50.673165,3.6305229",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 848,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GEEL (COLRUYT)",
    branchId: "4087",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1451825,
      longitude: 4.9546486,
    },
    address: {
      streetName: "ANTWERPSEWEG",
      houseNumber: "87",
      postalcode: "2440",
      cityName: "GEEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4087",
    routeUrl: "https://maps.apple.com/?daddr=51.1451825,4.9546486",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 490,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GEMBLOUX (COLRUYT)",
    branchId: "3132",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5691404,
      longitude: 4.6946881,
    },
    address: {
      streetName: "RUE DE LA SUCRERIE",
      houseNumber: "6",
      postalcode: "5030",
      cityName: "GEMBLOUX",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3132",
    routeUrl: "https://maps.apple.com/?daddr=50.5691404,4.6946881",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 486,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WINTERSLAG (COLRUYT)",
    branchId: "3125",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9768261,
      longitude: 5.4905236,
    },
    address: {
      streetName: "VENNESTRAAT",
      houseNumber: "225",
      postalcode: "3600",
      cityName: "GENK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3125",
    routeUrl: "https://maps.apple.com/?daddr=50.9768261,5.4905236",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3294,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GENK (COLRUYT)",
    branchId: "8072",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.960417046,
      longitude: 5.452281015,
    },
    address: {
      streetName: "HASSELTWEG",
      houseNumber: "214",
      postalcode: "3600",
      cityName: "GENK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/8072",
    routeUrl: "https://maps.apple.com/?daddr=50.960417046000,5.4522810150000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 710,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GENT (COLRUYT)",
    branchId: "3686",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.055831,
      longitude: 3.6942292,
    },
    address: {
      streetName: "DRONGENSESTEENWEG",
      houseNumber: "197",
      postalcode: "9000",
      cityName: "GENT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3686",
    routeUrl: "https://maps.apple.com/?daddr=51.055831,3.6942292",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 967,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GERPINNES (COLRUYT)",
    branchId: "4254",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.327984,
      longitude: 4.4765,
    },
    address: {
      streetName: "CHEE DE PHILIPPEVILLE",
      houseNumber: "271",
      postalcode: "6280",
      cityName: "GERPINNES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4254",
    routeUrl: "https://maps.apple.com/?daddr=50.327984,4.4765",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 695,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GILLY (COLRUYT)",
    branchId: "3662",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.423404,
      longitude: 4.4826741,
    },
    address: {
      streetName: "CHAUSSEE IMPERIALE",
      houseNumber: "61",
      postalcode: "6060",
      cityName: "GILLY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3662",
    routeUrl: "https://maps.apple.com/?daddr=50.423404,4.4826741",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 709,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GOSSELIES (COLRUYT)",
    branchId: "3685",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4599097,
      longitude: 4.4347989,
    },
    address: {
      streetName: "RUE TAHON",
      houseNumber: "37",
      postalcode: "6041",
      cityName: "GOSSELIES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3685",
    routeUrl: "https://maps.apple.com/?daddr=50.4599097,4.4347989",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1709,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GREZ-DOICEAU (COLRUYT)",
    branchId: "4457",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.737426,
      longitude: 4.659673,
    },
    address: {
      streetName: "CHAUSSEE DE WAVRE",
      houseNumber: "328",
      postalcode: "1390",
      cityName: "GREZ-DOICEAU",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4457",
    routeUrl: "https://maps.apple.com/?daddr=50.737426,4.659673",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 449,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GRIMBERGEN (COLRUYT)",
    branchId: "3077",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9356235,
      longitude: 4.3785596,
    },
    address: {
      streetName: "WOLVERTEMSESTEENWEG",
      houseNumber: "248",
      postalcode: "1850",
      cityName: "GRIMBERGEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3077",
    routeUrl: "https://maps.apple.com/?daddr=50.9356235,4.3785596",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3061,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CoMarkt Bouwel (Colruyt)",
    branchId: "7896",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1721094,
      longitude: 4.7387305,
    },
    address: {
      streetName: "LIERSE STEENWEG",
      houseNumber: "40",
      postalcode: "2280",
      cityName: "GROBBENDONK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7896",
    routeUrl: "https://maps.apple.com/?daddr=51.1721094,4.7387305",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 868,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HAACHT (COLRUYT)",
    branchId: "4116",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9732725,
      longitude: 4.6262825,
    },
    address: {
      streetName: "STATIONSSTRAAT",
      houseNumber: "113",
      postalcode: "3150",
      cityName: "HAACHT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4116",
    routeUrl: "https://maps.apple.com/?daddr=50.9732725,4.6262825",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 904,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HAALTERT (COLRUYT)",
    branchId: "4159",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8957352,
      longitude: 4.0007549,
    },
    address: {
      streetName: "HOOGSTRAAT",
      houseNumber: "131",
      postalcode: "9450",
      cityName: "HAALTERT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4159",
    routeUrl: "https://maps.apple.com/?daddr=50.8957352,4.0007549",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1010,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HACCOURT (COLRUYT)",
    branchId: "4360",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7315769,
      longitude: 5.6692726,
    },
    address: {
      streetName: "PLACE COMMUNALE",
      houseNumber: "1",
      postalcode: "4684",
      cityName: "HACCOURT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4360",
    routeUrl: "https://maps.apple.com/?daddr=50.7315769,5.6692726",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 604,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HALLE (COLRUYT)",
    branchId: "3515",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.726975,
      longitude: 4.215961,
    },
    address: {
      streetName: "EDINGENSESTEENWEG",
      houseNumber: "300",
      postalcode: "1500",
      cityName: "HALLE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3515",
    routeUrl: "https://maps.apple.com/?daddr=50.726975,4.215961",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 697,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HAMME (COLRUYT)",
    branchId: "3665",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0883227,
      longitude: 4.1368574,
    },
    address: {
      streetName: "DAMSTRAAT",
      houseNumber: "91",
      postalcode: "9220",
      cityName: "HAMME (O.-VL.)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3665",
    routeUrl: "https://maps.apple.com/?daddr=51.0883227,4.1368574",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 773,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HANNUT (COLRUYT)",
    branchId: "3834",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6840043,
      longitude: 5.0820931,
    },
    address: {
      streetName: "RUE DE LANDEN",
      houseNumber: "59",
      postalcode: "4280",
      cityName: "HANNUT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3834",
    routeUrl: "https://maps.apple.com/?daddr=50.6840043,5.0820931",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1670,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HARELBEKE (COLRUYT)",
    branchId: "4275",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8385885,
      longitude: 3.3110259,
    },
    address: {
      streetName: "STASEGEMSESTEENWEG",
      houseNumber: "180",
      postalcode: "8530",
      cityName: "HARELBEKE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4275",
    routeUrl: "https://maps.apple.com/?daddr=50.8385885,3.3110259",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 739,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HASSELT (COLRUYT)",
    branchId: "3741",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9284356,
      longitude: 5.3145603,
    },
    address: {
      streetName: "HENDRIK V. VELDEKESINGEL",
      houseNumber: "36",
      postalcode: "3500",
      cityName: "HASSELT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3741",
    routeUrl: "https://maps.apple.com/?daddr=50.9284356,5.3145603",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2654,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HECHTEL EKSEL (COLRUYT)",
    branchId: "7238",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1254452,
      longitude: 5.3706213,
    },
    address: {
      streetName: "PEERDERBAAN",
      houseNumber: "17",
      postalcode: "3940",
      cityName: "HECHTEL-EKSEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7238",
    routeUrl: "https://maps.apple.com/?daddr=51.1254452,5.3706213",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 464,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HEIST-OP-DEN-BERG (COLRUYT)",
    branchId: "3094",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0710339,
      longitude: 4.700673,
    },
    address: {
      streetName: "MECHELSESTEENWEG",
      houseNumber: "40",
      postalcode: "2220",
      cityName: "HEIST-OP-DEN-BERG",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3094",
    routeUrl: "https://maps.apple.com/?daddr=51.0710339,4.700673",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 682,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HELCHTEREN (COLRUYT)",
    branchId: "3645",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0886949,
      longitude: 5.3770841,
    },
    address: {
      streetName: "GROTE BAAN",
      houseNumber: "596",
      postalcode: "3530",
      cityName: "HELCHTEREN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3645",
    routeUrl: "https://maps.apple.com/?daddr=51.0886949,5.3770841",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 763,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HERENTALS (COLRUYT)",
    branchId: "3816",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1807329,
      longitude: 4.8325482,
    },
    address: {
      streetName: "BELGIELAAN",
      houseNumber: "42",
      postalcode: "2200",
      cityName: "HERENTALS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3816",
    routeUrl: "https://maps.apple.com/?daddr=51.1807329,4.8325482",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 493,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HERSTAL (COLRUYT)",
    branchId: "3135",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6595847,
      longitude: 5.6286099,
    },
    address: {
      streetName: "BOULEVARD ZENOBE GRAMME",
      houseNumber: "17",
      postalcode: "4040",
      cityName: "HERSTAL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3135",
    routeUrl: "https://maps.apple.com/?daddr=50.6595847,5.6286099",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 881,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HEUSY (COLRUYT)",
    branchId: "4130",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5846188,
      longitude: 5.883367,
    },
    address: {
      streetName: "AVENUE REINE ASTRID",
      houseNumber: "97",
      postalcode: "4802",
      cityName: "HEUSY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4130",
    routeUrl: "https://maps.apple.com/?daddr=50.5846188,5.883367",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 605,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HEVERLEE (COLRUYT)",
    branchId: "3516",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.87156,
      longitude: 4.6844635,
    },
    address: {
      streetName: "GROENVELDSTRAAT",
      houseNumber: "71",
      postalcode: "3001",
      cityName: "HEVERLEE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3516",
    routeUrl: "https://maps.apple.com/?daddr=50.87156,4.6844635",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 693,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HOBOKEN (COLRUYT)",
    branchId: "3660",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1713424,
      longitude: 4.3645575,
    },
    address: {
      streetName: "SINT-BERNARDSESTEENWEG",
      houseNumber: "777",
      postalcode: "2660",
      cityName: "HOBOKEN (ANTWERPEN)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3660",
    routeUrl: "https://maps.apple.com/?daddr=51.1713424,4.3645575",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 921,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HOOGLEDE.(COLRUYT)",
    branchId: "4189",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9748998,
      longitude: 3.0770433,
    },
    address: {
      streetName: "IEPERSTRAAT",
      houseNumber: "88",
      postalcode: "8830",
      cityName: "HOOGLEDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4189",
    routeUrl: "https://maps.apple.com/?daddr=50.9748998,3.0770433",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 898,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "HOOGSTRATEN (COLRUYT)",
    branchId: "4151",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.3904018,
      longitude: 4.7519294,
    },
    address: {
      streetName: "SINT LENAARTSEWEG",
      houseNumber: "20A",
      postalcode: "2320",
      cityName: "HOOGSTRATEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4151",
    routeUrl: "https://maps.apple.com/?daddr=51.3904018,4.7519294",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 491,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "IEPER (COLRUYT)",
    branchId: "3133",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8414791,
      longitude: 2.8860114,
    },
    address: {
      streetName: "RIJSELSEPOORT",
      houseNumber: "10",
      postalcode: "8900",
      cityName: "IEPER",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3133",
    routeUrl: "https://maps.apple.com/?daddr=50.8414791,2.8860114",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 779,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "IZEGEM (COLRUYT)",
    branchId: "3844",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9224373,
      longitude: 3.2037429,
    },
    address: {
      streetName: "NEDERWEG",
      houseNumber: "119",
      postalcode: "8870",
      cityName: "IZEGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3844",
    routeUrl: "https://maps.apple.com/?daddr=50.9224373,3.2037429",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1710,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "JAMBES (COLRUYT)",
    branchId: "4465",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.464704,
      longitude: 4.897115,
    },
    address: {
      streetName: "CHAUSSEE DE LIEGE",
      houseNumber: "477",
      postalcode: "5100",
      cityName: "JAMBES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4465",
    routeUrl: "https://maps.apple.com/?daddr=50.464704,4.897115",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 885,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "JEMAPPES (COLRUYT)",
    branchId: "4136",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4484959,
      longitude: 3.9033565,
    },
    address: {
      streetName: "AVENUE WILSON",
      houseNumber: "510",
      postalcode: "7012",
      cityName: "JEMAPPES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4136",
    routeUrl: "https://maps.apple.com/?daddr=50.4484959,3.9033565",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 645,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "JEMEPPE-SUR-MEUSE (COLRUYT)",
    branchId: "3587",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6181582,
      longitude: 5.4991626,
    },
    address: {
      streetName: "RUE DU BIEF",
      houseNumber: "2",
      postalcode: "4101",
      cityName: "JEMEPPE-SUR-MEUSE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3587",
    routeUrl: "https://maps.apple.com/?daddr=50.6181582,5.4991626",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 457,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SAMBREVILLE (COLRUYT)",
    branchId: "3086",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4555498,
      longitude: 4.6427713,
    },
    address: {
      streetName: "CHAUSSEE DE CHARLEROI",
      houseNumber: "39",
      postalcode: "5190",
      cityName: "JEMEPPE-SUR-SAMBRE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3086",
    routeUrl: "https://maps.apple.com/?daddr=50.4555498,4.6427713",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 612,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "JETTE (COLRUYT)",
    branchId: "3525",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.873263,
      longitude: 4.3278922,
    },
    address: {
      streetName: "LEOPOLD I STRAAT",
      houseNumber: "511B",
      postalcode: "1090",
      cityName: "JETTE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3525",
    routeUrl: "https://maps.apple.com/?daddr=50.873263,4.3278922",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 928,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "JODOIGNE (COLRUYT)",
    branchId: "4198",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7243166,
      longitude: 4.8762453,
    },
    address: {
      streetName: "RUE DE PIETRAIN",
      houseNumber: "36",
      postalcode: "1370",
      cityName: "JODOIGNE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4198",
    routeUrl: "https://maps.apple.com/?daddr=50.7243166,4.8762453",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 511,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KALMTHOUT (COLRUYT)",
    branchId: "3200",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.3817135,
      longitude: 4.4750611,
    },
    address: {
      streetName: "KAPELLENSTEENWEG",
      houseNumber: "186",
      postalcode: "2920",
      cityName: "KALMTHOUT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3200",
    routeUrl: "https://maps.apple.com/?daddr=51.3817135,4.4750611",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 922,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KEERBERGEN (COLRUYT)",
    branchId: "4190",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0072017,
      longitude: 4.6346503,
    },
    address: {
      streetName: "PUTSEBAAN",
      houseNumber: "75",
      postalcode: "3140",
      cityName: "KEERBERGEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4190",
    routeUrl: "https://maps.apple.com/?daddr=51.0072017,4.6346503",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 440,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KESSEL-LO (COLRUYT)",
    branchId: "3062",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8708744,
      longitude: 4.7267201,
    },
    address: {
      streetName: "TIENSESTEENWEG",
      houseNumber: "237",
      postalcode: "3010",
      cityName: "KESSEL-LO",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3062",
    routeUrl: "https://maps.apple.com/?daddr=50.8708744,4.7267201",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 768,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KNOKKE (COLRUYT)",
    branchId: "3829",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.3278015,
      longitude: 3.2955048,
    },
    address: {
      streetName: "NATIENLAAN",
      houseNumber: "191",
      postalcode: "8300",
      cityName: "KNOKKE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3829",
    routeUrl: "https://maps.apple.com/?daddr=51.3278015,3.2955048",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 873,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KOKSIJDE (COLRUYT)",
    branchId: "4121",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1061464,
      longitude: 2.6492578,
    },
    address: {
      streetName: "ZEELAAN",
      houseNumber: "39",
      postalcode: "8670",
      cityName: "KOKSIJDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4121",
    routeUrl: "https://maps.apple.com/?daddr=51.1061464,2.6492578",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 460,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KOMEN (COLRUYT)",
    branchId: "3089",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.774577,
      longitude: 3.0126034,
    },
    address: {
      streetName: "WERVIKSESTEENWEG",
      houseNumber: "164",
      postalcode: "7780",
      cityName: "KOMEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3089",
    routeUrl: "https://maps.apple.com/?daddr=50.774577,3.0126034",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 487,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KONTICH (COLRUYT)",
    branchId: "3127",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1348931,
      longitude: 4.4563914,
    },
    address: {
      streetName: "OOSTSTATIESTRAAT",
      houseNumber: "171",
      postalcode: "2550",
      cityName: "KONTICH",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3127",
    routeUrl: "https://maps.apple.com/?daddr=51.1348931,4.4563914",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 596,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KORTRIJK (COLRUYT)",
    branchId: "3492",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8230093,
      longitude: 3.2605202,
    },
    address: {
      streetName: "SINT-SEBASTIAANSLAAN",
      houseNumber: "2",
      postalcode: "8500",
      cityName: "KORTRIJK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3492",
    routeUrl: "https://maps.apple.com/?daddr=50.8230093,3.2605202",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 597,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KRAAINEM (COLRUYT)",
    branchId: "3494",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.8438738,
      longitude: 4.4714531,
    },
    address: {
      streetName: "FERDINAND KINNENSTRAAT",
      houseNumber: "9F",
      postalcode: "1950",
      cityName: "KRAAINEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3494",
    routeUrl: "https://maps.apple.com/?daddr=50.8438738,4.4714531",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 966,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KUURNE (COLRUYT)",
    branchId: "4253",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8465631,
      longitude: 3.2664742,
    },
    address: {
      streetName: "KLEINE RINGLAAN",
      houseNumber: "9",
      postalcode: "8520",
      cityName: "KUURNE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4253",
    routeUrl: "https://maps.apple.com/?daddr=50.8465631,3.2664742",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 701,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LA LOUVIERE (COLRUYT)",
    branchId: "3672",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4739164,
      longitude: 4.1818611,
    },
    address: {
      streetName: "RUE DU GAZOMETRE",
      houseNumber: "21",
      postalcode: "7100",
      cityName: "LA LOUVIERE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3672",
    routeUrl: "https://maps.apple.com/?daddr=50.4739164,4.1818611",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2623,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "Haine St Pierre (Colruyt)",
    branchId: "7142",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4639283254,
      longitude: 4.2077160714,
    },
    address: {
      streetName: "RUE DE BAUME-MARPENT",
      houseNumber: "30",
      postalcode: "7100",
      cityName: "LA LOUVIERE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7142",
    routeUrl: "https://maps.apple.com/?daddr=50.4639283254,4.2077160714",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 557,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LAKEN (COLRUYT)",
    branchId: "3425",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8714917,
      longitude: 4.3401937,
    },
    address: {
      streetName: "MAURICE DE MOORPLEIN",
      houseNumber: "7",
      postalcode: "1020",
      cityName: "LAKEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3425",
    routeUrl: "https://maps.apple.com/?daddr=50.8714917,4.3401937",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 900,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LANDEN (COLRUYT)",
    branchId: "4153",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7495283,
      longitude: 5.087942,
    },
    address: {
      streetName: "FABRIEKSTRAAT",
      houseNumber: "21",
      postalcode: "3400",
      cityName: "LANDEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4153",
    routeUrl: "https://maps.apple.com/?daddr=50.7495283,5.087942",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 623,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LEBBEKE (COLRUYT)",
    branchId: "3549",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9937725,
      longitude: 4.1326451,
    },
    address: {
      streetName: "BRUSSELSESTEENWEG",
      houseNumber: "110",
      postalcode: "9280",
      cityName: "LEBBEKE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3549",
    routeUrl: "https://maps.apple.com/?daddr=50.9937725,4.1326451",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 780,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LEDE (COLRUYT)",
    branchId: "3845",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9633075,
      longitude: 3.9772019,
    },
    address: {
      streetName: "HOOGSTRAAT",
      houseNumber: "44",
      postalcode: "9340",
      cityName: "LEDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3845",
    routeUrl: "https://maps.apple.com/?daddr=50.9633075,3.9772019",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 657,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LEDEBERG (COLRUYT)",
    branchId: "3606",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0356701,
      longitude: 3.7473294,
    },
    address: {
      streetName: "EDMOND VAN HOOREBEKESTR",
      houseNumber: "69",
      postalcode: "9050",
      cityName: "LEDEBERG",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3606",
    routeUrl: "https://maps.apple.com/?daddr=51.0356701,3.7473294",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 684,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LEUVEN (COLRUYT)",
    branchId: "3650",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8840921,
      longitude: 4.7013392,
    },
    address: {
      streetName: "LOMBAARDENSTRAAT",
      houseNumber: "2",
      postalcode: "3000",
      cityName: "LEUVEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3650",
    routeUrl: "https://maps.apple.com/?daddr=50.8840921,4.7013392",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 740,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LEUZE-EN-HAINAUT (COLRUYT)",
    branchId: "3743",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.595859,
      longitude: 3.6176676,
    },
    address: {
      streetName: "RUE DE CONDE",
      houseNumber: "56",
      postalcode: "7900",
      cityName: "LEUZE-EN-HAINAUT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3743",
    routeUrl: "https://maps.apple.com/?daddr=50.595859,3.6176676",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 485,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LIEDEKERKE (COLRUYT)",
    branchId: "3123",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8713644,
      longitude: 4.0915535,
    },
    address: {
      streetName: "KLEEMPUTTENSTRAAT",
      houseNumber: "65",
      postalcode: "1770",
      cityName: "LIEDEKERKE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3123",
    routeUrl: "https://maps.apple.com/?daddr=50.8713644,4.0915535",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 699,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LIEGE (GRETRY) COLRUYT",
    branchId: "3670",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.630339,
      longitude: 5.586252,
    },
    address: {
      streetName: "RUE GRETRY",
      houseNumber: "235",
      postalcode: "4020",
      cityName: "LIEGE 2",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3670",
    routeUrl: "https://maps.apple.com/?daddr=50.630339,5.586252",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 560,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LIEGE (CONSTITUTION) COLRUYT",
    branchId: "3435",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6431965,
      longitude: 5.5845517,
    },
    address: {
      streetName: "BLD DE LA CONSTITUTION",
      houseNumber: "32",
      postalcode: "4020",
      cityName: "LIEGE 2",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3435",
    routeUrl: "https://maps.apple.com/?daddr=50.6431965,5.5845517",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 456,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LIER (COLRUYT)",
    branchId: "3085",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1462901,
      longitude: 4.5404706,
    },
    address: {
      streetName: "ANTWERPSESTEENWEG",
      houseNumber: "344",
      postalcode: "2500",
      cityName: "LIER",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3085",
    routeUrl: "https://maps.apple.com/?daddr=51.1462901,4.5404706",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 508,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LOCHRISTI (COLRUYT)",
    branchId: "3180",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.09245,
      longitude: 3.815325,
    },
    address: {
      streetName: "ANTWERPSE STEENWEG",
      houseNumber: "44-46",
      postalcode: "9080",
      cityName: "LOCHRISTI",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3180",
    routeUrl: "https://maps.apple.com/?daddr=51.09245,3.815325",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 924,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LOKEREN (COLRUYT)",
    branchId: "4192",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1115104,
      longitude: 3.9615043,
    },
    address: {
      streetName: "GENTSE STEENWEG",
      houseNumber: "22",
      postalcode: "9160",
      cityName: "LOKEREN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4192",
    routeUrl: "https://maps.apple.com/?daddr=51.1115104,3.9615043",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 793,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LOMMEL (COLRUYT)",
    branchId: "3872",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2287681,
      longitude: 5.3189089,
    },
    address: {
      streetName: "KONING LEOPOLDLAAN",
      houseNumber: "37",
      postalcode: "3920",
      cityName: "LOMMEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3872",
    routeUrl: "https://maps.apple.com/?daddr=51.2287681,5.3189089",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 462,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LONDERZEEL (COLRUYT)",
    branchId: "3092",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0039916,
      longitude: 4.2998892,
    },
    address: {
      streetName: "MOLENSTRAAT",
      houseNumber: "39",
      postalcode: "1840",
      cityName: "LONDERZEEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3092",
    routeUrl: "https://maps.apple.com/?daddr=51.0039916,4.2998892",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 892,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MAASEIK (COLRUYT)",
    branchId: "4145",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.09585,
      longitude: 5.78327,
    },
    address: {
      streetName: "KLOOSTERBEMPDEN",
      houseNumber: "9",
      postalcode: "3680",
      cityName: "MAASEIK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4145",
    routeUrl: "https://maps.apple.com/?daddr=51.09585,5.78327",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 798,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MALDEGEM (COLRUYT)",
    branchId: "3886",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2037779,
      longitude: 3.4523249,
    },
    address: {
      streetName: "KONING LEOPOLDLAAN",
      houseNumber: "2",
      postalcode: "9990",
      cityName: "MALDEGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3886",
    routeUrl: "https://maps.apple.com/?daddr=51.2037779,3.4523249",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 805,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MALMEDY (COLRUYT)",
    branchId: "3905",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.424853,
      longitude: 6.0223238,
    },
    address: {
      streetName: "AVENUE DES ALLIES",
      houseNumber: "2",
      postalcode: "4960",
      cityName: "MALMEDY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3905",
    routeUrl: "https://maps.apple.com/?daddr=50.424853,6.0223238",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 771,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MARBAIS (COLRUYT)",
    branchId: "3832",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5728433,
      longitude: 4.5340424,
    },
    address: {
      streetName: "CHAUSSEE DE NAMUR",
      houseNumber: "264",
      postalcode: "1495",
      cityName: "MARBAIS (BR.W.)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3832",
    routeUrl: "https://maps.apple.com/?daddr=50.5728433,4.5340424",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 494,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MARCHE EN FAMENNE (COLRUYT)",
    branchId: "3136",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.2316203,
      longitude: 5.3433693,
    },
    address: {
      streetName: "VIEILLE ROUTE DE LIEGE",
      houseNumber: "10",
      postalcode: "6900",
      cityName: "MARCHE-EN-FAMENNE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3136",
    routeUrl: "https://maps.apple.com/?daddr=50.2316203,5.3433693",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 512,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MARCHIENNE-AU-PONT (COLRUYT)",
    branchId: "3201",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4090782096,
      longitude: 4.3930077553,
    },
    address: {
      streetName: "RUE LIEUTEN.GEN.GILLAIN",
      houseNumber: "43",
      postalcode: "6030",
      cityName: "MARCHIENNE-AU-PONT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3201",
    routeUrl: "https://maps.apple.com/?daddr=50.4090782096,4.3930077553",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 708,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MARCINELLE (COLRUYT)",
    branchId: "3683",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.3983485,
      longitude: 4.4471025,
    },
    address: {
      streetName: "RUE DU GRAND PONT",
      houseNumber: "16",
      postalcode: "6001",
      cityName: "MARCINELLE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3683",
    routeUrl: "https://maps.apple.com/?daddr=50.3983485,4.4471025",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 683,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MECHELEN (LIERSESTW) COLRUYT",
    branchId: "3649",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0445293,
      longitude: 4.4775242,
    },
    address: {
      streetName: "LIERSESTEENWEG",
      houseNumber: "351",
      postalcode: "2800",
      cityName: "MECHELEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3649",
    routeUrl: "https://maps.apple.com/?daddr=51.0445293,4.4775242",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 616,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MAASMECHELEN (COLRUYT)",
    branchId: "3540",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9413055,
      longitude: 5.692298,
    },
    address: {
      streetName: "RIJKSWEG",
      houseNumber: "583",
      postalcode: "3630",
      cityName: "MECHELEN-AAN-DE-MAAS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3540",
    routeUrl: "https://maps.apple.com/?daddr=50.9413055,5.692298",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 698,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MENEN (COLRUYT)",
    branchId: "3669",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.7981015,
      longitude: 3.1139812,
    },
    address: {
      streetName: "IEPERSTRAAT",
      houseNumber: "435",
      postalcode: "8930",
      cityName: "MENEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3669",
    routeUrl: "https://maps.apple.com/?daddr=50.7981015,3.1139812",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3323,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MERCHTEM (COLRUYT)",
    branchId: "8091",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.961041051,
      longitude: 4.238289022,
    },
    address: {
      streetName: "BLEUKENWEG",
      houseNumber: "5",
      postalcode: "1785",
      cityName: "MERCHTEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/8091",
    routeUrl: "https://maps.apple.com/?daddr=50.961041051000,4.2382890220000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 715,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MERELBEKE (COLRUYT)",
    branchId: "3691",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9917577,
      longitude: 3.7464714,
    },
    address: {
      streetName: "HUNDELGEMSESTEENWEG",
      houseNumber: "696",
      postalcode: "9820",
      cityName: "MERELBEKE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3691",
    routeUrl: "https://maps.apple.com/?daddr=50.9917577,3.7464714",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 583,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MERKSEM (ROOSENSPLEIN) COLRUYT",
    branchId: "3470",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.2491997,
      longitude: 4.4556283,
    },
    address: {
      streetName: "MOLENLEI",
      houseNumber: "1",
      postalcode: "2170",
      cityName: "MERKSEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3470",
    routeUrl: "https://maps.apple.com/?daddr=51.2491997,4.4556283",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 670,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MERKSEM (GROENENDAAL) COLRUYT",
    branchId: "3621",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2426711,
      longitude: 4.4307491,
    },
    address: {
      streetName: "GROENENDAALLAAN",
      houseNumber: "111",
      postalcode: "2170",
      cityName: "MERKSEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3621",
    routeUrl: "https://maps.apple.com/?daddr=51.2426711,4.4307491",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 753,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "METTET (COLRUYT)",
    branchId: "3777",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.3282111,
      longitude: 4.6555698,
    },
    address: {
      streetName: "RUE ALBERT-IER",
      houseNumber: "121",
      postalcode: "5640",
      cityName: "METTET",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3777",
    routeUrl: "https://maps.apple.com/?daddr=50.3282111,4.6555698",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 688,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MIDDELKERKE (COLRUYT)",
    branchId: "3654",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1938392,
      longitude: 2.8407762,
    },
    address: {
      streetName: "OOSTENDELAAN",
      houseNumber: "298",
      postalcode: "8430",
      cityName: "MIDDELKERKE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3654",
    routeUrl: "https://maps.apple.com/?daddr=51.1938392,2.8407762",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2819,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MOESKROEN (COLRUYT)",
    branchId: "7620",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7487954,
      longitude: 3.2134538,
    },
    address: {
      streetName: "MENENSTRAAT",
      houseNumber: "136",
      postalcode: "7700",
      cityName: "MOESKROEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7620",
    routeUrl: "https://maps.apple.com/?daddr=50.7487954,3.2134538",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 620,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MOL (COLRUYT)",
    branchId: "3544",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1898735,
      longitude: 5.1229459,
    },
    address: {
      streetName: "ROZENBERG",
      houseNumber: "64",
      postalcode: "2400",
      cityName: "MOL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3544",
    routeUrl: "https://maps.apple.com/?daddr=51.1898735,5.1229459",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 686,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MONS (COLRUYT)",
    branchId: "3652",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4520387,
      longitude: 3.9799625,
    },
    address: {
      streetName: "CHAUSSEE DE BINCHE",
      houseNumber: "123",
      postalcode: "7000",
      cityName: "MONS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3652",
    routeUrl: "https://maps.apple.com/?daddr=50.4520387,3.9799625",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 672,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MORLANWELZ (COLRUYT)",
    branchId: "3623",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4593717,
      longitude: 4.23407,
    },
    address: {
      streetName: "CHAUSSEE DE MARIEMONT",
      houseNumber: "36",
      postalcode: "7140",
      cityName: "MORLANWELZ-MARIEMONT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3623",
    routeUrl: "https://maps.apple.com/?daddr=50.4593717,4.23407",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 988,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MORTSEL (COLRUYT)",
    branchId: "4316",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1739169,
      longitude: 4.467963,
    },
    address: {
      streetName: "DRABSTRAAT",
      houseNumber: "172",
      postalcode: "2640",
      cityName: "MORTSEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4316",
    routeUrl: "https://maps.apple.com/?daddr=51.1739169,4.467963",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 749,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SALZINNES (COLRUYT)",
    branchId: "3768",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4627865,
      longitude: 4.842535,
    },
    address: {
      streetName: "CHAUSSEE DE CHARLEROI",
      houseNumber: "16",
      postalcode: "5000",
      cityName: "NAMUR",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3768",
    routeUrl: "https://maps.apple.com/?daddr=50.4627865,4.842535",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 884,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "KELMIS (COLRUYT)",
    branchId: "4135",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7165301,
      longitude: 6.0174596,
    },
    address: {
      streetName: "LUTTICHER STRASSE",
      houseNumber: "145",
      postalcode: "4721",
      cityName: "NEU-MORESNET",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4135",
    routeUrl: "https://maps.apple.com/?daddr=50.7165301,6.0174596",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 958,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "NIEUWPOORT (COLRUYT)",
    branchId: "4232",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.137091,
      longitude: 2.739978,
    },
    address: {
      streetName: "JOZEF CARDIJNLAAN",
      houseNumber: "33-A",
      postalcode: "8620",
      cityName: "NIEUWPOORT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4232",
    routeUrl: "https://maps.apple.com/?daddr=51.137091,2.739978",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 859,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "NIMY (COLRUYT)",
    branchId: "4106",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4825433,
      longitude: 3.9531295,
    },
    address: {
      streetName: "RUE DES VIADUCS",
      houseNumber: "287",
      postalcode: "7020",
      cityName: "NIMY",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4106",
    routeUrl: "https://maps.apple.com/?daddr=50.4825433,3.9531295",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 901,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "NINOVE (COLRUYT)",
    branchId: "4154",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.835282,
      longitude: 4.0164286,
    },
    address: {
      streetName: "POLDERBAAN",
      houseNumber: "26",
      postalcode: "9400",
      cityName: "NINOVE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4154",
    routeUrl: "https://maps.apple.com/?daddr=50.835282,4.0164286",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 595,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "NIVELLES (COLRUYT)",
    branchId: "3490",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6103227,
      longitude: 4.3361374,
    },
    address: {
      streetName: "CHAUSSEE DE BRUXELLES",
      houseNumber: "170",
      postalcode: "1400",
      cityName: "NIVELLES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3490",
    routeUrl: "https://maps.apple.com/?daddr=50.6103227,4.3361374",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3794,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "NOORDERWIJK HERENTALS COLRUYT",
    branchId: "9165",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.129458596,
      longitude: 4.829864192,
    },
    address: {
      streetName: "MORKHOVENSEWEG",
      houseNumber: "92",
      postalcode: "2200",
      cityName: "NOORDERWIJK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/9165",
    routeUrl: "https://maps.apple.com/?daddr=51.129458596000,4.8298641920000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 618,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "NOSSEGEM (COLRUYT)",
    branchId: "3542",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8779442,
      longitude: 4.5121293,
    },
    address: {
      streetName: "VOSKAPELLELAAN",
      houseNumber: "11",
      postalcode: "1930",
      cityName: "NOSSEGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3542",
    routeUrl: "https://maps.apple.com/?daddr=50.8779442,4.5121293",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 980,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OOSTENDE (COLRUYT)",
    branchId: "4271",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.20742,
      longitude: 2.9046004,
    },
    address: {
      streetName: "TORHOUTSESTEENWEG",
      houseNumber: "529",
      postalcode: "8400",
      cityName: "OOSTENDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4271",
    routeUrl: "https://maps.apple.com/?daddr=51.20742,2.9046004",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 794,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OOSTROZEBEKE (COLRUYT)",
    branchId: "3873",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9199957,
      longitude: 3.3220892,
    },
    address: {
      streetName: "INGELMUNSTERSTEENWEG",
      houseNumber: "16",
      postalcode: "8780",
      cityName: "OOSTROZEBEKE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3873",
    routeUrl: "https://maps.apple.com/?daddr=50.9199957,3.3220892",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2733,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OPWIJK (COLRUYT)",
    branchId: "7382",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9613243,
      longitude: 4.2027375,
    },
    address: {
      streetName: "STEENWEG OP MERCHTEM",
      houseNumber: "137",
      postalcode: "1745",
      cityName: "OPWIJK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7382",
    routeUrl: "https://maps.apple.com/?daddr=50.9613243,4.2027375",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 641,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OTTIGNIES (LE DOUAIRE) COLRUYT",
    branchId: "3583",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6632026,
      longitude: 4.5670411,
    },
    address: {
      streetName: "AVENUE DU DOUAIRE",
      houseNumber: "2038",
      postalcode: "1340",
      cityName: "OTTIGNIES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3583",
    routeUrl: "https://maps.apple.com/?daddr=50.6632026,4.5670411",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 644,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OUD-TURNHOUT (COLRUYT)",
    branchId: "3586",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.3206744,
      longitude: 4.9685303,
    },
    address: {
      streetName: "BLEKERIJSTRAAT",
      houseNumber: "2",
      postalcode: "2360",
      cityName: "OUD-TURNHOUT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3586",
    routeUrl: "https://maps.apple.com/?daddr=51.3206744,4.9685303",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 447,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OUDENAARDE (COLRUYT)",
    branchId: "3070",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8466031,
      longitude: 3.6016008,
    },
    address: {
      streetName: "TACAMBAROPLEIN",
      houseNumber: "3",
      postalcode: "9700",
      cityName: "OUDENAARDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3070",
    routeUrl: "https://maps.apple.com/?daddr=50.8466031,3.6016008",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 459,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OUDERGEM (COLRUYT)",
    branchId: "3088",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8249117,
      longitude: 4.3975257,
    },
    address: {
      streetName: "TRIOMFLAAN",
      houseNumber: "20",
      postalcode: "1160",
      cityName: "OUDERGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3088",
    routeUrl: "https://maps.apple.com/?daddr=50.8249117,4.3975257",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 712,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "GERAARDSBERGEN (COLRUYT)",
    branchId: "3688",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.757921,
      longitude: 3.8533638,
    },
    address: {
      streetName: "GROTEWEG",
      houseNumber: "373",
      postalcode: "9500",
      cityName: "OVERBOELARE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3688",
    routeUrl: "https://maps.apple.com/?daddr=50.757921,3.8533638",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 606,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "OVERIJSE (COLRUYT)",
    branchId: "3517",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7888732,
      longitude: 4.4935415,
    },
    address: {
      streetName: "BRUSSELSESTEENWEG",
      houseNumber: "482A",
      postalcode: "3090",
      cityName: "OVERIJSE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3517",
    routeUrl: "https://maps.apple.com/?daddr=50.7888732,4.4935415",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 498,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "PELT (COLRUYT)",
    branchId: "3146",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.229601,
      longitude: 5.440668,
    },
    address: {
      streetName: "HEERSTRAAT",
      houseNumber: "68",
      postalcode: "3910",
      cityName: "PELT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3146",
    routeUrl: "https://maps.apple.com/?daddr=51.229601,5.440668",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2812,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "PERUWELZ NEW (COLRUYT)",
    branchId: "7613",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5250918,
      longitude: 3.600576,
    },
    address: {
      streetName: "RUE NEUVE CHAUSSEE",
      houseNumber: "157",
      postalcode: "7600",
      cityName: "PERUWELZ",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7613",
    routeUrl: "https://maps.apple.com/?daddr=50.5250918,3.600576",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 784,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "POPERINGE (COLRUYT)",
    branchId: "3854",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8538532,
      longitude: 2.7187854,
    },
    address: {
      streetName: "DUINKERKESTRAAT",
      houseNumber: "56",
      postalcode: "8970",
      cityName: "POPERINGE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3854",
    routeUrl: "https://maps.apple.com/?daddr=50.8538532,2.7187854",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1680,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BASECLES (COLRUYT)",
    branchId: "4464",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.509281,
      longitude: 3.6857541,
    },
    address: {
      streetName: "RUE DE TOURNAI",
      houseNumber: "167",
      postalcode: "7972",
      cityName: "QUEVAUCAMPS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4464",
    routeUrl: "https://maps.apple.com/?daddr=50.509281,3.6857541",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 713,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "RAMSEL (COLRUYT)",
    branchId: "3689",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0322028,
      longitude: 4.8317456,
    },
    address: {
      streetName: "STATIONSSTRAAT",
      houseNumber: "9",
      postalcode: "2230",
      cityName: "RAMSEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3689",
    routeUrl: "https://maps.apple.com/?daddr=51.0322028,4.8317456",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 759,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LIBRAMONT (COLRUYT)",
    branchId: "3812",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 49.9182398,
      longitude: 5.3610037,
    },
    address: {
      streetName: "LE BLANCHEAU",
      houseNumber: "8",
      postalcode: "6800",
      cityName: "RECOGNE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3812",
    routeUrl: "https://maps.apple.com/?daddr=49.9182398,5.3610037",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 776,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "RIXENSART (COLRUYT)",
    branchId: "3838",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7150541,
      longitude: 4.5306387,
    },
    address: {
      streetName: "RUE AVIATEUR HUENS",
      houseNumber: "16",
      postalcode: "1330",
      cityName: "RIXENSART",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3838",
    routeUrl: "https://maps.apple.com/?daddr=50.7150541,4.5306387",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2712,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ROCHEFORT (COLRUYT)",
    branchId: "7314",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.1661255,
      longitude: 5.2112912,
    },
    address: {
      streetName: "RUE DE DINANT",
      houseNumber: "4",
      postalcode: "5580",
      cityName: "ROCHEFORT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7314",
    routeUrl: "https://maps.apple.com/?daddr=50.1661255,5.2112912",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 899,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "RUMBEKE (COLRUYT)",
    branchId: "4152",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9395091,
      longitude: 3.131306,
    },
    address: {
      streetName: "HEROPBOUWSTRAAT",
      houseNumber: "163",
      postalcode: "8800",
      cityName: "ROESELARE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4152",
    routeUrl: "https://maps.apple.com/?daddr=50.9395091,3.131306",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 754,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ROESELARE (COLRUYT)",
    branchId: "3785",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.9464175,
      longitude: 3.1155993,
    },
    address: {
      streetName: "DIKSMUIDSESTEENWEG",
      houseNumber: "114",
      postalcode: "8800",
      cityName: "ROESELARE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3785",
    routeUrl: "https://maps.apple.com/?daddr=50.9464175,3.1155993",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1659,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "RONSE (COLRUYT)",
    branchId: "4244",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7453978,
      longitude: 3.5933188,
    },
    address: {
      streetName: "OSWALD PONETTESTRAAT",
      houseNumber: "52",
      postalcode: "9600",
      cityName: "RONSE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4244",
    routeUrl: "https://maps.apple.com/?daddr=50.7453978,3.5933188",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 609,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MONTEGNEE (COLRUYT)",
    branchId: "3522",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6401477,
      longitude: 5.5340283,
    },
    address: {
      streetName: "RUE ADOLPHE RENSON",
      houseNumber: "17",
      postalcode: "4420",
      cityName: "SAINT-NICOLAS(LIEGE)",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3522",
    routeUrl: "https://maps.apple.com/?daddr=50.6401477,5.5340283",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1008,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SART-JALHAY (COLRUYT)",
    branchId: "4357",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5116838,
      longitude: 5.9047799,
    },
    address: {
      streetName: "BALMORAL",
      houseNumber: "1",
      postalcode: "4845",
      cityName: "SART-LEZ-SPA",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4357",
    routeUrl: "https://maps.apple.com/?daddr=50.5116838,5.9047799",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 469,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SCHAARBEEK (ROODEBEEKLN) COLR",
    branchId: "3102",
    sourceStatus: "IN",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8477002,
      longitude: 4.3973611,
    },
    address: {
      streetName: "ROODEBEEKLAAN",
      houseNumber: "17",
      postalcode: "1030",
      cityName: "SCHAARBEEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3102",
    routeUrl: "https://maps.apple.com/?daddr=50.8477002,4.3973611",
    isActive: false,
    placeSearchOpeningHours: [],
  },
  {
    placeId: 558,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SCHAARBEEK (JERUZALEMSTR) COLR",
    branchId: "3427",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8670483,
      longitude: 4.3778952,
    },
    address: {
      streetName: "JERUSALEMSTRAAT",
      houseNumber: "8-16",
      postalcode: "1030",
      cityName: "SCHAARBEEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3427",
    routeUrl: "https://maps.apple.com/?daddr=50.8670483,4.3778952",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2826,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SCHAARBEEK MEISER (COLRUYT)",
    branchId: "7627",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8535943,
      longitude: 4.3932807,
    },
    address: {
      streetName: "LEUVENSESTEENWEG",
      houseNumber: "510",
      postalcode: "1030",
      cityName: "SCHAARBEEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7627",
    routeUrl: "https://maps.apple.com/?daddr=50.8535943,4.3932807",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 551,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SCHERPENHEUVEL (COLRUYT)",
    branchId: "3390",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9728851,
      longitude: 4.9718434,
    },
    address: {
      streetName: "AUGUST NIHOULSTRAAT",
      houseNumber: "139",
      postalcode: "3270",
      cityName: "SCHERPENHEUVEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3390",
    routeUrl: "https://maps.apple.com/?daddr=50.9728851,4.9718434",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 451,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SCHOTEN (COLRUYT)",
    branchId: "3079",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2592673,
      longitude: 4.506286,
    },
    address: {
      streetName: "PAALSTRAAT",
      houseNumber: "275",
      postalcode: "2900",
      cityName: "SCHOTEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3079",
    routeUrl: "https://maps.apple.com/?daddr=51.2592673,4.506286",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 553,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SERAING (COLRUYT)",
    branchId: "3404",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5805176,
      longitude: 5.5076822,
    },
    address: {
      streetName: "RUE PUITS-MARIE",
      houseNumber: "61",
      postalcode: "4100",
      cityName: "SERAING",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3404",
    routeUrl: "https://maps.apple.com/?daddr=50.5805176,5.5076822",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 762,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT-AMANDSBERG (COLRUYT)",
    branchId: "3815",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.0521888,
      longitude: 3.7529881,
    },
    address: {
      streetName: "DENDERMONDSESTEENWEG",
      houseNumber: "409",
      postalcode: "9040",
      cityName: "SINT-AMANDSBERG",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3815",
    routeUrl: "https://maps.apple.com/?daddr=51.0521888,3.7529881",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 631,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "BRUGGE SINT-ANDRIES (COLRUYT)",
    branchId: "3566",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1987583,
      longitude: 3.1885507,
    },
    address: {
      streetName: "GISTELSE STEENWEG",
      houseNumber: "345",
      postalcode: "8200",
      cityName: "SINT-ANDRIES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3566",
    routeUrl: "https://maps.apple.com/?daddr=51.1987583,3.1885507",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1825,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT-DENIJS-WESTREM (COLRUYT)",
    branchId: "4591",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0154063,
      longitude: 3.6550922,
    },
    address: {
      streetName: "KORTRIJKSESTEENWEG",
      houseNumber: "1238",
      postalcode: "9051",
      cityName: "SINT-DENIJS-WESTREM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4591",
    routeUrl: "https://maps.apple.com/?daddr=51.0154063,3.6550922",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 923,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT GILLIS WAAS (COLRUYT)",
    branchId: "4191",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2222899,
      longitude: 4.1236521,
    },
    address: {
      streetName: "BLOKSTRAAT",
      houseNumber: "8",
      postalcode: "9170",
      cityName: "SINT-GILLIS-WAAS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4191",
    routeUrl: "https://maps.apple.com/?daddr=51.2222899,4.1236521",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 639,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ST-KAT-WAVER (PASBRUG) COLRUYT",
    branchId: "3579",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.035262,
      longitude: 4.514898,
    },
    address: {
      streetName: "PUTSESTEENWEG",
      houseNumber: "87",
      postalcode: "2860",
      cityName: "SINT-KATELIJNE-WAVER",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3579",
    routeUrl: "https://maps.apple.com/?daddr=51.035262,4.514898",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1059,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT-NIKLAAS SMISSTR. COLRUYT",
    branchId: "4596",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1490884,
      longitude: 4.1360154,
    },
    address: {
      streetName: "SMISSTRAAT",
      houseNumber: "109",
      postalcode: "9100",
      cityName: "SINT-NIKLAAS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4596",
    routeUrl: "https://maps.apple.com/?daddr=51.1490884,4.1360154",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 453,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT-NIKLAAS NIJVERH. COLRUYT",
    branchId: "3082",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1705699,
      longitude: 4.1359718,
    },
    address: {
      streetName: "NIJVERHEIDSSTRAAT",
      houseNumber: "54",
      postalcode: "9100",
      cityName: "SINT-NIKLAAS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3082",
    routeUrl: "https://maps.apple.com/?daddr=51.1705699,4.1359718",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 726,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT-PIETERS-LEEUW (COLRUYT)",
    branchId: "3711",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.79696,
      longitude: 4.2860431,
    },
    address: {
      streetName: "BERGENSESTEENWEG",
      houseNumber: "201",
      postalcode: "1600",
      cityName: "SINT-PIETERS-LEEUW",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3711",
    routeUrl: "https://maps.apple.com/?daddr=50.79696,4.2860431",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 577,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT-TRUIDEN (COLRUYT)",
    branchId: "3463",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8128958,
      longitude: 5.1530114,
    },
    address: {
      streetName: "TIENSESTEENWEG",
      houseNumber: "266",
      postalcode: "3800",
      cityName: "SINT-TRUIDEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3463",
    routeUrl: "https://maps.apple.com/?daddr=50.8128958,5.1530114",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 844,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SOIGNIES (COLRUYT)",
    branchId: "4073",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5848934,
      longitude: 4.078696,
    },
    address: {
      streetName: "CHEMIN SAINT-LANDRY",
      houseNumber: "10A",
      postalcode: "7060",
      cityName: "SOIGNIES",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4073",
    routeUrl: "https://maps.apple.com/?daddr=50.5848934,4.078696",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 727,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "MOLENBEEK (COLRUYT)",
    branchId: "3715",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8615151,
      longitude: 4.3022628,
    },
    address: {
      streetName: "GENTSESTEENWEG",
      houseNumber: "362",
      postalcode: "1080",
      cityName: "ST-JANS-MOLENBEEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3715",
    routeUrl: "https://maps.apple.com/?daddr=50.8615151,4.3022628",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 474,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "SINT-PIETERS-WOLUWE (COLRUYT)",
    branchId: "3108",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8368454,
      longitude: 4.4319045,
    },
    address: {
      streetName: "PIERRE DE COCKSTRAAT",
      houseNumber: "5",
      postalcode: "1150",
      cityName: "ST-PIETERS-WOLUWE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3108",
    routeUrl: "https://maps.apple.com/?daddr=50.8368454,4.4319045",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 619,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "STABROEK (COLRUYT)",
    branchId: "3543",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.3324858,
      longitude: 4.361944,
    },
    address: {
      streetName: "ABTSDREEF",
      houseNumber: "10/E",
      postalcode: "2940",
      cityName: "STABROEK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3543",
    routeUrl: "https://maps.apple.com/?daddr=51.3324858,4.361944",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 725,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TEMSE (COLRUYT)",
    branchId: "3707",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1286756,
      longitude: 4.2190716,
    },
    address: {
      streetName: "VRIJHEIDSTRAAT",
      houseNumber: "19",
      postalcode: "9140",
      cityName: "TEMSE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3707",
    routeUrl: "https://maps.apple.com/?daddr=51.1286756,4.2190716",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 865,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TERTRE (COLRUYT)",
    branchId: "4113",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4697365,
      longitude: 3.815698,
    },
    address: {
      streetName: "RUE DEFUISSEAUX",
      houseNumber: "49",
      postalcode: "7333",
      cityName: "TERTRE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4113",
    routeUrl: "https://maps.apple.com/?daddr=50.4697365,3.815698",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3453,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TESSENDERLO (COLRUYT)",
    branchId: "8206",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.057042596,
      longitude: 5.088901157,
    },
    address: {
      streetName: "DIESTERSTRAAT",
      houseNumber: "174",
      postalcode: "3980",
      cityName: "TESSENDERLO",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/8206",
    routeUrl: "https://maps.apple.com/?daddr=51.057042596000,5.0889011570000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 3789,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "CADI THUIN 2",
    branchId: "8552",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.339180876,
      longitude: 4.30941494,
    },
    address: {
      streetName: "DREVE DES ALLIES",
      houseNumber: "108",
      postalcode: "6530",
      cityName: "THUIN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/8552",
    routeUrl: "https://maps.apple.com/?daddr=50.339180876000,4.3094149400000",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1708,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TIELT (COLRUYT)",
    branchId: "4224",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9979051,
      longitude: 3.3174381,
    },
    address: {
      streetName: "DEKEN DARRASLAAN",
      houseNumber: "66",
      postalcode: "8700",
      cityName: "TIELT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4224",
    routeUrl: "https://maps.apple.com/?daddr=50.9979051,3.3174381",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 893,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TIENEN DRINKCENTER (COLRUYT)",
    branchId: "4146",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    geoCoordinates: {
      latitude: 50.8113793,
      longitude: 4.9233157,
    },
    address: {
      streetName: "ZIJDELINGSESTRAAT",
      houseNumber: "54",
      postalcode: "3300",
      cityName: "TIENEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4146",
    routeUrl: "https://maps.apple.com/?daddr=50.8113793,4.9233157",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 513,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TIENEN (COLRUYT)",
    branchId: "3202",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8117093,
      longitude: 4.9231461,
    },
    address: {
      streetName: "ZIJDELINGSESTRAAT",
      houseNumber: "64",
      postalcode: "3300",
      cityName: "TIENEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3202",
    routeUrl: "https://maps.apple.com/?daddr=50.8117093,4.9231461",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 883,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TONGEREN (COLRUYT)",
    branchId: "4134",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7767772,
      longitude: 5.45953,
    },
    address: {
      streetName: "ASTRIDLAAN",
      houseNumber: "33",
      postalcode: "3700",
      cityName: "TONGEREN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4134",
    routeUrl: "https://maps.apple.com/?daddr=50.7767772,5.45953",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 452,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TORHOUT (COLRUYT)",
    branchId: "3080",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0617274,
      longitude: 3.0999977,
    },
    address: {
      streetName: "KORTEMARKSTRAAT",
      houseNumber: "25",
      postalcode: "8820",
      cityName: "TORHOUT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3080",
    routeUrl: "https://maps.apple.com/?daddr=51.0617274,3.0999977",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 785,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TOURNAI(CH.DE RENAIX)(COLRUYT)",
    branchId: "3855",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6160116,
      longitude: 3.4120794,
    },
    address: {
      streetName: "CHAUSSEE DE RENAIX",
      houseNumber: "113",
      postalcode: "7500",
      cityName: "TOURNAI",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3855",
    routeUrl: "https://maps.apple.com/?daddr=50.6160116,3.4120794",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 750,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "TOURNAI (COLRUYT)",
    branchId: "3769",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6100394,
      longitude: 3.387091,
    },
    address: {
      streetName: "QUAI DES SALINES",
      houseNumber: "2",
      postalcode: "7500",
      cityName: "TOURNAI",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3769",
    routeUrl: "https://maps.apple.com/?daddr=50.6100394,3.387091",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 696,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "UKKEL STALLE (COLRUYT)",
    branchId: "3663",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.79664,
      longitude: 4.3238012,
    },
    address: {
      streetName: "STALLESTRAAT",
      houseNumber: "161",
      postalcode: "1180",
      cityName: "UKKEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3663",
    routeUrl: "https://maps.apple.com/?daddr=50.79664,4.3238012",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1057,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "LANAKEN (COLRUYT)",
    branchId: "4593",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8790518,
      longitude: 5.6289736,
    },
    address: {
      streetName: "KIEZELWEG",
      houseNumber: "16",
      postalcode: "3620",
      cityName: "VELDWEZELT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4593",
    routeUrl: "https://maps.apple.com/?daddr=50.8790518,5.6289736",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 473,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "VERVIERS (COLRUYT)",
    branchId: "3107",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.5916607,
      longitude: 5.8475732,
    },
    address: {
      streetName: "BOULEVARD D GERARDCHAMPS",
      houseNumber: "60",
      postalcode: "4800",
      cityName: "VERVIERS",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3107",
    routeUrl: "https://maps.apple.com/?daddr=50.5916607,5.8475732",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 495,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "VEURNE (COLRUYT)",
    branchId: "3137",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0701104,
      longitude: 2.6686143,
    },
    address: {
      streetName: "VAARTSTRAAT",
      houseNumber: "18",
      postalcode: "8630",
      cityName: "VEURNE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3137",
    routeUrl: "https://maps.apple.com/?daddr=51.0701104,2.6686143",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 554,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "VILVOORDE (MUTSAERT) COLRUYT",
    branchId: "3417",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9020736,
      longitude: 4.3613101,
    },
    address: {
      streetName: "MUTSAERTPLAATS",
      houseNumber: "23",
      postalcode: "1800",
      cityName: "VILVOORDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3417",
    routeUrl: "https://maps.apple.com/?daddr=50.9020736,4.3613101",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 626,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "VILVOORDE (SCHAARBEEKLEI) COLR",
    branchId: "3559",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9241043,
      longitude: 4.4265794,
    },
    address: {
      streetName: "SCHAARBEEKLEI",
      houseNumber: "57",
      postalcode: "1800",
      cityName: "VILVOORDE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3559",
    routeUrl: "https://maps.apple.com/?daddr=50.9241043,4.4265794",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 925,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "VIRTON (COLRUYT)",
    branchId: "4193",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 49.5658632,
      longitude: 5.5190936,
    },
    address: {
      streetName: "RUE DE MONTMEDY",
      houseNumber: "14",
      postalcode: "6760",
      cityName: "VIRTON",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4193",
    routeUrl: "https://maps.apple.com/?daddr=49.5658632,5.5190936",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 566,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "VORST (COLRUYT)",
    branchId: "3451",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8099916,
      longitude: 4.3260109,
    },
    address: {
      streetName: "VICTOR ROUSSEAULAAN",
      houseNumber: "208",
      postalcode: "1190",
      cityName: "VORST",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3451",
    routeUrl: "https://maps.apple.com/?daddr=50.8099916,4.3260109",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 834,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "VOSSELAAR (COLRUYT)",
    branchId: "4051",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.316678,
      longitude: 4.901886,
    },
    address: {
      streetName: "ANTWERPSESTEENWEG",
      houseNumber: "21",
      postalcode: "2350",
      cityName: "VOSSELAAR",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4051",
    routeUrl: "https://maps.apple.com/?daddr=51.316678,4.901886",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2624,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WALCOURT (COLRUYT)",
    branchId: "7148",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.2634606,
      longitude: 4.4353238,
    },
    address: {
      streetName: "RUE ST.DONAT",
      houseNumber: "23",
      postalcode: "5650",
      cityName: "WALCOURT",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7148",
    routeUrl: "https://maps.apple.com/?daddr=50.2634606,4.4353238",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 755,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WAREGEM (COLRUYT)",
    branchId: "3795",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY"],
    handoverServices: ["CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 50.8900546,
      longitude: 3.422303,
    },
    address: {
      streetName: "NOORDERLAAN",
      houseNumber: "50",
      postalcode: "8790",
      cityName: "WAREGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3795",
    routeUrl: "https://maps.apple.com/?daddr=50.8900546,3.422303",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 647,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WAREMME (COLRUYT)",
    branchId: "3589",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6976925,
      longitude: 5.2506662,
    },
    address: {
      streetName: "RUE DU MOULIN",
      houseNumber: "17",
      postalcode: "4300",
      cityName: "WAREMME",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3589",
    routeUrl: "https://maps.apple.com/?daddr=50.6976925,5.2506662",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 465,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "QUAREGNON (COLRUYT)",
    branchId: "3096",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.4399931,
      longitude: 3.84467,
    },
    address: {
      streetName: "SENTIER DU PIED VERT",
      houseNumber: "10",
      postalcode: "7390",
      cityName: "WASMUEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3096",
    routeUrl: "https://maps.apple.com/?daddr=50.4399931,3.84467",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 497,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WATERLOO (COLRUYT)",
    branchId: "3144",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.6940329,
      longitude: 4.4037911,
    },
    address: {
      streetName: "CHAUSSEE DE BRUXELLES",
      houseNumber: "684",
      postalcode: "1410",
      cityName: "WATERLOO",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3144",
    routeUrl: "https://maps.apple.com/?daddr=50.6940329,4.4037911",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 624,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WAVRE (COLRUYT)",
    branchId: "3555",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.7169591,
      longitude: 4.6155928,
    },
    address: {
      streetName: "AVENUE DES PRINCES",
      houseNumber: "45",
      postalcode: "1300",
      cityName: "WAVRE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3555",
    routeUrl: "https://maps.apple.com/?daddr=50.7169591,4.6155928",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 861,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WELLIN (COLRUYT)",
    branchId: "4108",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.0812316,
      longitude: 5.1179829,
    },
    address: {
      streetName: "RUE DE LA STATION",
      houseNumber: "26",
      postalcode: "6920",
      cityName: "WELLIN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4108",
    routeUrl: "https://maps.apple.com/?daddr=50.0812316,5.1179829",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 1792,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WEMMEL (COLRUYT)",
    branchId: "4544",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.8964,
      longitude: 4.321005,
    },
    address: {
      streetName: "ROMEINSE STEENWEG",
      houseNumber: "906",
      postalcode: "1780",
      cityName: "WEMMEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4544",
    routeUrl: "https://maps.apple.com/?daddr=50.8964,4.321005",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 977,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WEPION (COLRUYT)",
    branchId: "4268",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.3923555,
      longitude: 4.8779397,
    },
    address: {
      streetName: "CHAUSSEE DE DINANT",
      houseNumber: "1320",
      postalcode: "5100",
      cityName: "WEPION",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4268",
    routeUrl: "https://maps.apple.com/?daddr=50.3923555,4.8779397",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 559,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WESTMALLE (COLRUYT)",
    branchId: "3433",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2973417,
      longitude: 4.6872094,
    },
    address: {
      streetName: "ANTWERPSESTEENWEG",
      houseNumber: "335",
      postalcode: "2390",
      cityName: "WESTMALLE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3433",
    routeUrl: "https://maps.apple.com/?daddr=51.2973417,4.6872094",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 613,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WETTEREN (COLRUYT)",
    branchId: "3536",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0005391,
      longitude: 3.8726541,
    },
    address: {
      streetName: "GENTSESTEENWEG",
      houseNumber: "95",
      postalcode: "9230",
      cityName: "WETTEREN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3536",
    routeUrl: "https://maps.apple.com/?daddr=51.0005391,3.8726541",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 611,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WILRIJK (COLRUYT)",
    branchId: "3524",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1747576,
      longitude: 4.3948029,
    },
    address: {
      streetName: "LAARSTRAAT",
      houseNumber: "34",
      postalcode: "2610",
      cityName: "WILRIJK",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3524",
    routeUrl: "https://maps.apple.com/?daddr=51.1747576,4.3948029",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 926,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WOMMELGEM (COLRUYT)",
    branchId: "4195",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1970228,
      longitude: 4.5161654,
    },
    address: {
      streetName: "HERENTALSEBAAN",
      houseNumber: "587",
      postalcode: "2160",
      cityName: "WOMMELGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4195",
    routeUrl: "https://maps.apple.com/?daddr=51.1970228,4.5161654",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 912,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "WONDELGEM (COLRUYT)",
    branchId: "4176",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0880513,
      longitude: 3.709028,
    },
    address: {
      streetName: "BOTESTRAAT",
      houseNumber: "23",
      postalcode: "9032",
      cityName: "WONDELGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4176",
    routeUrl: "https://maps.apple.com/?daddr=51.0880513,3.709028",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 665,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ZEDELGEM (COLRUYT)",
    branchId: "3615",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["3RDPARTY", "QUALITY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.1429929,
      longitude: 3.1338667,
    },
    address: {
      streetName: "SINT-LAURENTIUSSTRAAT",
      houseNumber: "32",
      postalcode: "8210",
      cityName: "ZEDELGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3615",
    routeUrl: "https://maps.apple.com/?daddr=51.1429929,3.1338667",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 556,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ZELE (COLRUYT)",
    branchId: "3421",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.0656944,
      longitude: 4.0301161,
    },
    address: {
      streetName: "LANGE AKKER",
      houseNumber: "2-6",
      postalcode: "9240",
      cityName: "ZELE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3421",
    routeUrl: "https://maps.apple.com/?daddr=51.0656944,4.0301161",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 483,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ZELZATE (COLRUYT)",
    branchId: "3120",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 51.2012712,
      longitude: 3.8079068,
    },
    address: {
      streetName: "WESTKADE",
      houseNumber: "6",
      postalcode: "9060",
      cityName: "ZELZATE",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3120",
    routeUrl: "https://maps.apple.com/?daddr=51.2012712,3.8079068",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 891,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ZOERSEL (COLRUYT)",
    branchId: "4143",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["PREPAID_PARCEL", "CSOP_ORDERABLE"],
    geoCoordinates: {
      latitude: 51.2669014,
      longitude: 4.6401541,
    },
    address: {
      streetName: "ZOERSELSTEENWEG",
      houseNumber: "8A",
      postalcode: "2980",
      cityName: "ZOERSEL",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/4143",
    routeUrl: "https://maps.apple.com/?daddr=51.2669014,4.6401541",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 2830,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ZONHOVEN (COLRUYT)",
    branchId: "7651",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.9771478,
      longitude: 5.3643159,
    },
    address: {
      streetName: "HEUVENEINDEWEG",
      houseNumber: "62",
      postalcode: "3520",
      cityName: "ZONHOVEN",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/7651",
    routeUrl: "https://maps.apple.com/?daddr=50.9771478,5.3643159",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
  {
    placeId: 653,
    ensign: {
      id: 8,
      name: "COLR_Colruyt",
    },
    commercialName: "ZOTTEGEM (COLRUYT)",
    branchId: "3599",
    sourceStatus: "AC",
    placeType: {
      id: 1,
      longName: "Winkel",
      placeTypeDescription: "Winkel",
    },
    sellingPartners: ["QUALITY", "3RDPARTY"],
    handoverServices: ["CSOP_ORDERABLE", "PREPAID_PARCEL"],
    geoCoordinates: {
      latitude: 50.87875,
      longitude: 3.828794,
    },
    address: {
      streetName: "BIJLOKESTRAAT",
      houseNumber: "2",
      postalcode: "9620",
      cityName: "ZOTTEGEM",
      countryName: "België",
      countryCode: "BE",
    },
    moreInfoUrl: "https://www.colruyt.be/nl/colruyt-openingsuren/3599",
    routeUrl: "https://maps.apple.com/?daddr=50.87875,3.828794",
    isActive: true,
    placeSearchOpeningHours: [
      {
        date: "02-11-2023",
        opens: 830,
        closes: 2000,
        isToday: true,
        isOpenForTheDay: true,
      },
      {
        date: "03-11-2023",
        opens: 830,
        closes: 2100,
        isToday: false,
        isOpenForTheDay: true,
      },
    ],
  },
];
